<template>
  <div>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <div>
          <div v-if='exportFlag'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-add" title='导出模板'/></div>
          <div v-if='btns.upgrade'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" title='升级' @click='upFun'/></div>
          <div v-if='btns.back'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" title='回退' @click='backFun'/></div>
        </div>
      </ejs-toolbar>
    </div>
    <div>
      <!--<ejs-grid ref='grid' :dataSource="data" :allowResizing='true' height="calc(100% - 0px)">-->
        <!--<e-columns>-->
          <!--<e-column type='checkbox' headerText='id' minwidth='30' textAlign='Center'></e-column>-->
          <!--<e-column field='state' :headerText="$t('状态')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='name' :headerText="$t('名称')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='category' :headerText="$t('服务类别')" width='150' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          <!--<e-column field='deliveryType' :headerText="$t('交付类型')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='descripe' :headerText="$t('介绍')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='createTime' :headerText="$t('上架时间')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='version' :headerText="$t('版本')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='runEnvironment' :headerText="$t('部署环境')" width='150' textAlign='Center'></e-column>-->
          <!--<e-column field='id' :headerText="$t('操作')" width='150' textAlign='Center' :template='detailTemplate'></e-column>-->
        <!--</e-columns>-->
      <!--</ejs-grid>-->
      <Table ref="grid"></Table>
    </div>
    <!--<ejs-pager ref="grpPager" @click='getGridData(node)' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount'></ejs-pager>-->
    <CustomDialog ref='serDlg' :element='serDlg.element' :styles='styles'>
      <template v-slot:dialog-content>
        <ServerVersion ref='server'></ServerVersion>
      </template>
    </CustomDialog>
    <CustomDialog ref='deDlg' :element='deDlg.element' :styles='styles'>
      <template v-slot:dialog-content>
        <DeviceVersion ref='device'></DeviceVersion>
      </template>
    </CustomDialog>
    <CustomDialog ref='deployedDetailPage' :element='dialog.eleDeployedDetailPage' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <DeployedDetailDialog ref='deployedDetail'></DeployedDetailDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import detailTemplate from './DetailTemplate';
import ServerVersion from './ServerVersion';
import DeviceVersion from './DeviceVersion';
import CustomDialog from '../../common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import HandlerResTool from './resHandlerCommon';
import Table from '../serverManagement/Table';
import DeployedDetailDialog from './DeployedDetailDialog';

export default {
  name: 'DeployedTable',
  props: [
    'exportFlag'
  ],
  data() {
    return {
      data: [],
      btns: {
        upgrade: true,
        back: true,
      },
      deliverMap: { // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: 'native',
        1: 'image',
        2: 'helm'
      },
      envirMap: {
        1: 'DP',
        2: 'k8s',
        3: 'server',
        4: 'device'
      },
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        35: this.$t('Topo.neCU'),
        36: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl')
      },
      detailTemplate(args) {
        return {
          template: detailTemplate
        };
      },
      styles: {
        width: '810px',
        height: '752px',
        model: true,
        visible: false
      },
      serDlg: {
        element: {
          refName: "serDlg",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {
              click: this.dialogHide,
              buttonModel: {
                content: `${this.$t("Common.confirm")}`,
                isPrimary: true
              }
            }
          ],
          title: this.$t('服务版本切换')
        }
      },
      deDlg: {
        element: {
          refName: "deDlg",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Common.cancel') } },
            {
              click: this.deConDlg,
              buttonModel: {
                content: `${this.$t("Common.confirm")}`,
                isPrimary: true
              }
            }
          ],
          title: this.$t('设备版本切换')
        }
      },
      dialog: {
        eleDeployedDetailPage: {
          target: this.$refs.deployedDetail,
          refName: 'deployedDetail',
          buttonGroup: [
            {
              click: this.closeDeployedDetailPage,
              buttonModel: { content: this.$t('SubscriberIms.cancel') }
            }
          ],
          title: this.$t('DeployManagement.detail'),
          isClose: true
        },
        styles: {
          width: '55%',
          height: '80%',
          visible: false,
          model: true
        }
      },
      oper: undefined,
      param: undefined
    };
  },
  methods: {
    getDeployedGrid(args) {
      const $this = this;
      // const temp = [{ idFlag: '1_1_1.0.1', state: 1, name: 'AMF', category: '1', deliveryType: '1', descripe: '这是测试的哈', createTime: '2020-04-03 14:37:02', version: '1.0.1', runEnvironment: '5gc运行环境' }];
      // $this.data = temp;
      const paramSend = {
        url: '/lte/ems/deployed/queryAll',
        config: {},
        formData: {

        },
        callFun: $this.initDataCallFun,
        load: this.param.load,
        $axios: this.param.$axios
      };
      $this.oper.$GetRequest(paramSend);
    },
    initDataCallFun(response) {
      const $this = this;
      const res = response.data;
      $this.data = res;
    },
    upFun() {
      const param = this.checkSame();
      if (param == null) {
        return null;
      }
      param['upOrBack'] = 0;
      // 1-dp 2-k8s 3-server 4-device
      const runEnvironmentId = param['dataSource'][0]['runEnvironmentId'];
      if (runEnvironmentId < 4) {
        // 服务升级
        this.$refs.server.init(param);
        this.$refs.serDlg.show();
      } else {
        // 设备升级
        this.$refs.device.init(param);
        this.$refs.deDlg.show();
      }
    },
    backFun() {
      const param = this.checkSame();
      if (param == null) {
        return null;
      }
      param['upOrBack'] = 1;
      // 1-dp 2-k8s 3-server 4-device
      const runEnvironmentId = param['dataSource'][0]['runEnvironmentId'];
      if (runEnvironmentId < 4) {
        // 服务回退
        this.$refs.server.init(param);
        this.$refs.serDlg.show();
      } else {
        // 设备回退
        this.$refs.device.init(param);
        this.$refs.deDlg.show();
      }
    },
    checkSame() {
      // const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      const record = this.getSelectRecords();
      if (record.length === 0) {
        this.eventEmit('warning', `${this.$t("请选择服务")}`);
        return null;
      }
      const obj = {};
      const serverType = record.reduceRight((item, next) => {
        obj[next.category] ? '' : obj[next.category] = true && item.push(next);
        return item;
      }, []);
      if (serverType.length > 1) {
        this.eventEmit('warning', '请选择同类型服务');
        return null;
      }
      const param = {
        oamTypeCode: record[0]['oamTypeCode'],
        dataSource: record
      };
      return param;
    },
    deConDlg() {
      this.$refs.device.confirm();
    },
    dialogHide() {
      this.$refs.serDlg.clear();
      this.$refs.serDlg.close();
      this.$refs.deDlg.clear();
      this.$refs.deDlg.close();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    },
    // 获取grid选中的数据
    getSelectRecords() {
      const record = this.$refs.grid.$refs.grid.getSelectedRecords();
      return record;
    },
    openDeployedDetailPage() {
      this.$refs.deployedDetailPage.show();
      // this.$refs.deployedDetail.initTable();
    },
    closeDeployedDetailPage() {
      this.$refs.deployedDetailPage.clear();
      this.$refs.deployedDetailPage.close();
    }
  },
  components: {
    DeployedDetailDialog,
    ServerVersion,
    DeviceVersion,
    CustomDialog,
    Table
  },
  mounted() {
    this.oper = new HandlerResTool();
    this.param = {
      load: this.$loading,
      $axios: this.$axios
    };
  },
  created() {
    EventBus.$on('openDetailPage', target => {
      this.openDeployedDetailPage(target);
    });
  }
};
</script>

<style scoped>

</style>
